/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategorySuggestion
 */
export interface CategorySuggestion {
    /**
     * 
     * @type {string}
     * @memberof CategorySuggestion
     */
    familyId: string;
    /**
     * 
     * @type {string}
     * @memberof CategorySuggestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CategorySuggestion
     */
    label: string;
}

/**
 * Check if a given object implements the CategorySuggestion interface.
 */
export function instanceOfCategorySuggestion(value: object): value is CategorySuggestion {
    if (!('familyId' in value) || value['familyId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function CategorySuggestionFromJSON(json: any): CategorySuggestion {
    return CategorySuggestionFromJSONTyped(json, false);
}

export function CategorySuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategorySuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'familyId': json['familyId'],
        'id': json['id'],
        'label': json['label'],
    };
}

export function CategorySuggestionToJSON(value?: CategorySuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'familyId': value['familyId'],
        'id': value['id'],
        'label': value['label'],
    };
}

